export function isNodePathSelected(selectedNodePath, path) {
  return path.join('.') === selectedNodePath.join('.');
}
